export default __webpack_public_path__ + "static/media/img3.e01d7787.png";